export const AwsProductsEnum = [
  { value: 'AmazonRedshift', display: 'Amazon RedShift' },
  { value: 'AWSAppFabric', display: 'AWS App Fabric' },
  { value: 'AWSCleanRooms', display: 'AWS Clean Rooms' },
];
